<ng-container *ngIf="isBrowser(); else staticContent">
  <!-- Lo normal de tu app -->
  <router-outlet></router-outlet>
</ng-container>

<ng-template #staticContent>
  <!-- Contenido estático mínimo para prerender / no-JS -->
  <app-pre-render />
</ng-template>
